import _ from 'lodash'

class AccountSettingsController {

  constructor($log, accountService, CurrentUserService, Billing, PasswordResetService, Base64, $window) {
    this.$log = $log
    this.service = accountService

    this.Billing = Billing
    this.CurrentUserService = CurrentUserService
    this.PasswordResetService = PasswordResetService

    // Hold a deep copy of the user, we don't want to connect to the
    // actual $storage user, which may be used from other parts of the app
    this.user = _.clone(this.CurrentUserService.current)
    this.referralLink = this.CurrentUserService.createReferralLink();
    this.submitting = false
    this.errorMessage = ""
    this.successMessage = ""
  }

  // The form isn't available when the controller is initialized, so inject it via ng-init
  // Its injected solely to support setting the form back to pristine condition after the update
  setSettingsForm(formScope) {
    this._settingsFormScope = formScope
  }

  update() {
    this.$log.debug("Updating!")
    this.submitting = true
    this.service.update(
      this.user,
      this._onUpdateSuccess.bind(this),
      this._onUpdateFailure.bind(this)
    )
  }

  _onUpdateSuccess(response) {
    this.successMessage = "You have successfully updated your account information."

    this.CurrentUserService.current = response.data.user
    // clone it for the form binding - we don't want changes to the form
    // to impact the actual user
    this.user = _.clone(this.CurrentUserService.current)

    this.submitting = false
    if (this._settingsFormScope && this._settingsFormScope.settingsForm) {
      this._settingsFormScope.settingsForm.$setPristine()
    }
  }

  _onUpdateFailure(response) {
    this.errorMessage = "User update failed. (" + response.status + ")"
    this.$log.debug(this.errorMessage)
    this.submitting = false
  }

  sendPasswordResetRequest() {
    this._clearResetMessages()

    this.PasswordResetService.requestResetPasswordEmail(
      this.user.email,
      this._onResetEmailGenerated.bind(this),
      this._onResetEmailNotGenerated.bind(this))

    this.resetRequestSubmitting = true
  }

  _clearResetMessages() {
    this.resetSuccessMessage = null
    this.resetErrorMessage = null
  }

  _onResetEmailGenerated() {
    this.resetRequestSubmitting = false
    this.resetSuccessMessage = 'Your password reset request was sent successfully. You should receive an email shortly.'
  }

  _onResetEmailNotGenerated() {
    this.resetRequestSubmitting = false
    this.resetErrorMessage = 'Sorry, there was a problem with your reset request. Please try again later. If the problem continues, please contact us at support.oseberg.io.'
  }
}

AccountSettingsController.$inject = [
  '$log',
  'AccountService',
  'CurrentUserService',
  'Billing',
  'PasswordResetService',
  'Base64',
  '$window'
]

export default AccountSettingsController
